//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { delBpmId } from "@/api/bpmnApi/bpmn";
export default {
  name: "IframeView",
  components: {},
  props: {
    "append-to-body": {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: false,
      iframeUrl: "",
      iviewId: "",
      taskInstId: "",
      hideType: 0
    };
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {
    window.addEventListener("message", this.listerIframeOff);
  },
  destroyed: function destroyed() {
    window.removeEventListener("message", this.listerIframeOff);
  },
  methods: {
    showView: function showView(url, taskInstId) {
      if (!url) {
        return;
      }

      this.iframeUrl = url;
      this.iviewId = "iframeId" + taskInstId;
      this.taskInstId = taskInstId;
      this.hideType = 0;
      this.show = true;
    },
    listerIframeOff: function listerIframeOff(e) {
      var _this = this;

      if (e.data.code == "aws-hide") {
        this.hideType = e.data.hideType;
        window.sessionStorage.setItem("processInstId", "");
        this.$nextTick(function () {
          _this.iframeUrl = "";

          _this.$emit("sub-true");

          _this.show = false;
        });
      }
    },
    closed: function closed() {
      var _this2 = this;

      var iframe = document.getElementById(this.iviewId);
      iframe.contentWindow.postMessage({
        code: "web",
        taskInstId: this.taskInstId
      }, "*");

      if (window.sessionStorage.getItem("processInstId")) {
        this.$confirm("确认是否退出并保存该条申请?", "提示", {
          confirmButtonText: "保存",
          cancelButtonText: "不保存",
          type: "warning"
        }).then(function () {
          iframe.contentWindow.postMessage({
            code: "doSaveData",
            taskInstId: _this2.taskInstId
          }, "*");
          _this2.show = false;
          window.sessionStorage.setItem("processInstId", "");
          setTimeout(function () {
            _this2.iframeUrl = "";
          }, 1000);

          switch (_this2.hideType) {
            case 1:
              _this2.$emit("fetch-list");

              break;

            case 2:
              _this2.$emit("init-page");

              break;

            case 3:
              window.location.reload();
              break;

            default:
              _this2.$emit("fetch-list");

              break;
          }
        }).catch(function () {
          var params = {
            instId: window.sessionStorage.getItem("processInstId") || ""
          };
          delBpmId(params).then(function (res) {
            if (res.data.code == "0") {
              _this2.$message.success("删除流程成功");

              window.sessionStorage.setItem("processInstId", "");
              _this2.iframeUrl = "";

              switch (_this2.hideType) {
                case 1:
                  _this2.$emit("fetch-list");

                  break;

                case 2:
                  _this2.$emit("init-page");

                  break;

                case 3:
                  window.location.reload();
                  break;

                default:
                  _this2.$emit("fetch-list");

                  break;
              }

              _this2.show = false;
            } else {
              _this2.$message.warning(res.data.msg || "删除流程失败，请重新操作!");
            }
          });
        });
      } else {
        this.show = false;

        switch (this.hideType) {
          case 1:
            this.$emit("fetch-list");
            break;

          case 2:
            this.$emit("init-page");
            break;

          case 3:
            window.location.reload();
            break;

          default:
            this.$emit("fetch-list");
            break;
        }
      }
    },
    //关闭清除
    dialogClose: function dialogClose() {
      this.iframeUrl = "";
      this.show = false;
    }
  },
  watch: {},
  filters: {}
};